import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import StateComponents from '../../../../components/state-component/StateComponents';
import AccordionCustom from '../../../../components/accordion/AccordionCustom';
import { onlineCourseFormSurveys, RadioCourseOnlineValue, STATUS_ONLINE_COURSE_FORM, STATUS_ONLINE_COURSE_FORM_TYPE } from '../manage-surveys/enum/manage_surveys.enum';
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom';
import RadioCustom from '../../../../components/radio/RadioCustom';
import InputTextField from '../../../../components/input/inputTextField';
import { Button, IconButton, Typography } from '@mui/material';

// ICON
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DescriptionIcon from '@mui/icons-material/Description';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import ContainerButton from '../../../../components/button/ContainerButton';
import { IconComponent } from '../../../../assets/icons/icons';
import { OnlineCourseApi, OnlineCourseForm } from '../../../../api/online-corse/online_course.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { useTranslation } from 'react-i18next'

type Props = {
    view: boolean;
}

const ManageCourseTestDetail: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    type formChoiceType = {
        is_correct: boolean;
        form_choice_name: string;
        id_online_course_form_choice: number | null
    }
    type DataType = {
        form_type: string;
        question: string;
        answer: string;
        answer_required: boolean;
        online_course_form_subject_point: string;
        id_online_course_form_subject: number | null;
        form_choice: formChoiceType[]
    }
    const [title_name, set_title_name] = useState<string>("");
    const [online_course_form_status, set_online_course_form_status] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<{ title_name: string }>({
        title_name: ""
    })
    const [data, setData] = useState<DataType[]>([
        {
            form_type: "",
            question: "",
            id_online_course_form_subject: null,
            answer: "",
            answer_required: true,
            online_course_form_subject_point: "",
            form_choice: []
        },
    ])

    const clearErrorMessage = () => {
        setErrorMessage({ title_name: "" })
    }

    const AddForm = () => {
        const new_form: DataType = {
            form_type: "",
            id_online_course_form_subject: null,
            online_course_form_subject_point: "",
            question: "",
            answer: "",
            answer_required: true,
            form_choice: []
        }
        setData((prev) => ([...prev, new_form]))
    }
    const handleChange = (field: keyof DataType, index: number, value: any) => {
        clearErrorMessage();
        setData(prevData => {
            const newData = [...prevData];
            const updatedItem = { ...newData[index], [field]: value };
            newData[index] = updatedItem;
            return newData;
        });
    };
    const handleChangeFormChoice = (field: keyof formChoiceType, index: number, sub_index: number, value: string | boolean) => {
        clearErrorMessage();
        setData(prevData => {
            const newData = [...prevData];
            const updatedItem = { ...newData[index].form_choice[sub_index], [field]: value };
            newData[index].form_choice[sub_index] = updatedItem;
            return newData;
        });
    };
    const handleDeleteForm = (index: number) => {
        setData((prev) => prev.filter((_, i) => i !== index))
    };
    const handleDeleteFormChoice = (index: number, sub_index: number) => {
        setData(prevData => {
            const newData = [...prevData];
            const updatedFormChoice = [...newData[index].form_choice];
            updatedFormChoice.splice(sub_index, 1); // ลบตาม sub_index
            newData[index] = {
                ...newData[index],
                form_choice: updatedFormChoice
            };

            return newData;
        });
    };
    const handleAddFormChoice = (index: number) => {
        const item_data: formChoiceType = {
            form_choice_name: "ตัวเลือก", // i18n-ignore: default choice value saved to backend
            is_correct: false,
            id_online_course_form_choice: null
        }
        setData(prevData => {
            const newData = [...prevData];
            const updatedFormChoice = [...newData[index].form_choice];
            updatedFormChoice.push(item_data);
            newData[index] = {
                ...newData[index],
                form_choice: updatedFormChoice
            };

            return newData;
        });
    };


    const handleGetDetail = async (id_online_course_form: number) => {
        dispatch(setLoading());
        await OnlineCourseApi.findOneForm(id_online_course_form).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const course_form_subject = data?.course_form_subject || []
                const online_course_form_status_value = data?.online_course_form_status || ""
                set_online_course_form_status(online_course_form_status_value);
                const form_data_value = course_form_subject?.map((list: any) => {
                    return {
                        form_type: list?.online_course_form_subject_type || "",
                        question: list?.online_course_form_subject || "",
                        id_online_course_form_subject: list?.id_online_course_form_subject || null,
                        online_course_form_subject_point: list?.online_course_form_subject_point ? String(list?.online_course_form_subject_point) : "",
                        answer: list?.choices?.length > 0 ? list?.choices?.findIndex((x: any) => x?.online_course_form_choice_true) : "",
                        answer_required: true,
                        form_choice: list?.choices?.length > 0 ? list?.choices?.map((sub: any, i: number) => {
                            let online_course_form_choice_true = 0;
                            if (list?.online_course_form_subject_type === onlineCourseFormSurveys.SINGLE_CHOICE) {
                                const is_correct = i === +list.answer ? 1 : 0
                                online_course_form_choice_true = is_correct
                            } else if (list?.online_course_form_subject_type === onlineCourseFormSurveys.MULTI_CHOICE) {
                                online_course_form_choice_true = sub?.online_course_form_choice_true ? 1 : 0
                            } else if (list.form_type === onlineCourseFormSurveys.DESCRIPTION) {
                                online_course_form_choice_true = 1
                            }
                            return {
                                form_choice_name: sub?.online_course_form_choice || "",
                                is_correct: online_course_form_choice_true ? true : false,
                                id_online_course_form_choice: sub?.id_online_course_form_choice || null
                            }
                        }) : []
                    }
                })
                setData(form_data_value);
                set_title_name(data?.online_course_form_name || "")
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const validateData = (check_all?: boolean): boolean => {
        let is_not_valid: boolean = false;
        if (!title_name) {
            setErrorMessage((prev) => ({ ...prev, title_name: t("ระบุชื่อแบบทดสอบ") }))
            return true
        }
        if (data?.length > 0 && data?.some((x) => !x?.form_type)) {
            alertError(t("ระบุข้อมูลรูปแบบให้ครบถ้วน"))
            return true
        }
        return is_not_valid
    }
    const generateForm = (status: string): OnlineCourseForm => {
        return {
            online_course_form_name: title_name,
            online_course_form_status: status,
            online_course_form_type: STATUS_ONLINE_COURSE_FORM_TYPE.MANAGE_QUIZ,
            course_form_subject: data.map((list) => {
                return {
                    id_online_course_form_subject: list.id_online_course_form_subject,
                    online_course_form_subject: list.question,
                    online_course_form_subject_point: list.online_course_form_subject_point ? +list.online_course_form_subject_point : null,
                    online_course_form_subject_type: list.form_type,
                    require_answer: list.answer_required ? 1 : 0,
                    choices: list?.form_choice?.length > 0 ? list.form_choice?.map((sub, i) => {
                        let online_course_form_choice_true = 0;
                        if (list.form_type === onlineCourseFormSurveys.SINGLE_CHOICE) {
                            const is_correct = i === +list.answer ? 1 : 0
                            online_course_form_choice_true = is_correct
                        } else if (list.form_type === onlineCourseFormSurveys.MULTI_CHOICE) {
                            online_course_form_choice_true = sub.is_correct ? 1 : 0
                        }
                        return {
                            id_online_course_form_choice: sub.id_online_course_form_choice,
                            online_course_form_choice_type: "",
                            online_course_form_choice: sub.form_choice_name,
                            online_course_form_choice_true: online_course_form_choice_true,
                            online_course_form_choice_point: 0//ใช้ในจัดการแบบทดสอบ
                        }
                    }) : [],
                }
            })
        }
    }
    const handleSubmit = async (mode: "SUBMIT" | "DRAFT") => {
        const body = generateForm(mode === 'DRAFT' ? STATUS_ONLINE_COURSE_FORM.DRAFT : STATUS_ONLINE_COURSE_FORM.ACTIVE);
        const validate_data = validateData(mode === 'SUBMIT');
        if (validate_data) return;
        if (id) {
            if (mode === 'SUBMIT') {
                alertActive(t("บันทึกข้อมูล"), t("ท่านต้องการบันทึกข้อมูลพร้อมยืนยันแบบฟอร์ม?"), undefined, undefined, async () => {
                    dispatch(setLoading());
                    await OnlineCourseApi.updateForm(+id, body).then((res) => {
                        if (res.status < 300) {
                            handleGetDetail(+id);
                            alertSuccess(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล สำเร็จ"))
                        }
                    }).catch((err) => {
                        console.log(err)
                        alertError(t("บันทึกไม่สำเร็จ"), t("เกิดข้อผิดพลาดในการบันทึกข้อมูล"))
                    }).finally(() => {
                        dispatch(unsetLoading());
                    })
                })
            } else {
                dispatch(setLoading());
                await OnlineCourseApi.updateForm(+id, body).then((res) => {
                    if (res.status < 300) {
                        handleGetDetail(+id);
                        alertSuccess(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล สำเร็จ"))
                    }
                }).catch((err) => {
                    console.log(err)
                    alertError(t("บันทึกไม่สำเร็จ"), t("เกิดข้อผิดพลาดในการบันทึกข้อมูล"))
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            }
        } else {
            if (mode === 'SUBMIT') {
                alertActive(t("บันทึกข้อมูล"), t("ท่านต้องการบันทึกข้อมูลพร้อมยืนยันแบบฟอร์ม?"), undefined, undefined, async () => {
                    dispatch(setLoading());
                    await OnlineCourseApi.createForm(body).then((res) => {
                        if (res.status < 300) {
                            const id_online_course_form = res.data?.data?.id_online_course_form || null;
                            if (id_online_course_form) {
                                alertSuccess(t("บันทึกข้อมูล"), t("บันทึกข้อมูลสำเร็จ"), undefined, () => {
                                    window.location.replace(routeName.cms.course_online_surveys_detail.replace(":id", id_online_course_form))
                                })
                                setTimeout(() => {
                                    window.location.replace(routeName.cms.course_online_surveys_detail.replace(":id", id_online_course_form))
                                }, 2000)
                            } else {
                                alertSuccess(t("บันทึกข้อมูล"), t("บันทึกข้อมูลสำเร็จ"));
                                navigate(routeName.cms.course_online_surveys)
                            }
                        }
                    }).catch((err) => {
                        console.log(err)
                        alertError(t("บันทึกไม่สำเร็จ"), t("เกิดข้อผิดพลาดในการบันทึกข้อมูล"))
                    }).finally(() => {
                        dispatch(unsetLoading());
                    })
                })
            } else {
                dispatch(setLoading());
                await OnlineCourseApi.createForm(body).then((res) => {
                    if (res.status < 300) {
                        const id_online_course_form = res.data?.data?.id_online_course_form || null;
                        if (id_online_course_form) {
                            alertSuccess(t("บันทึกข้อมูล"), t("บันทึกข้อมูลสำเร็จ"), undefined, () => {
                                window.location.replace(routeName.cms.course_online_surveys_detail.replace(":id", id_online_course_form))
                            })
                            setTimeout(() => {
                                window.location.replace(routeName.cms.course_online_surveys_detail.replace(":id", id_online_course_form))
                            }, 2000)
                        } else {
                            alertSuccess(t("บันทึกข้อมูล"), t("บันทึกข้อมูลสำเร็จ"));
                            navigate(routeName.cms.course_online_surveys)
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    alertError(t("บันทึกไม่สำเร็จ"), t("เกิดข้อผิดพลาดในการบันทึกข้อมูล"))
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            }
        }

    }

    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
        }
    }, [])

    return (
        <ContainerLayout
            title={view ? t("รายละเอียดแบบทดสอบ") : id ? t("รายละเอียดแบบทดสอบ") : t("เพิ่มแบบทดสอบ")}
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: t("จัดการข้อมูลคอร์สออนไลน์"),
                            name: t("จัดการข้อมูลคอร์สออนไลน์"),
                            disabled_match: true,
                            pathName: ""
                        },
                        {
                            key: t("จัดการแบบทดสอบ"),
                            name: t("จัดการแบบทดสอบ"),
                            pathName: routeName.cms.course_online_quiz
                        },
                        ...((id && !view) ? [
                            {
                                key: t("รายละเอียดแบบทดสอบ"),
                                name: t("รายละเอียดแบบทดสอบ"),
                                pathName: routeName.cms.course_online_quiz_detail.replace(":id", id)
                            },
                        ] : (id && view) ? [
                            {
                                key: t("แบบทดสอบ"),
                                name: t("แบบทดสอบ"),
                                pathName: routeName.cms.course_online_quiz_view.replace(":id", id)
                            },
                        ] : [
                            {
                                key: t("เพิ่มแบบทดสอบ"),
                                name: t("เพิ่มแบบทดสอบ"),
                                pathName: routeName.cms.course_online_quiz_create
                            },
                        ])
                    ]}
                />
            }
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            key: "CANCEL",
                            label: t("ยกเลิก"),
                            seq: 1,
                            buttonProps: {
                                onClick: () => navigate(routeName.cms.course_online_quiz)
                            },
                            type: "CANCEL"
                        },
                        {
                            key: "SAVE_DRAFT",
                            label: t("บันทึกร่าง", { context: "action" }),
                            hidden: view || online_course_form_status === STATUS_ONLINE_COURSE_FORM.ACTIVE,
                            seq: 2,
                            buttonProps: {
                                onClick: () => handleSubmit('DRAFT')
                            },
                            type: "SAVE_DRAFT"
                        },
                        {
                            key: "SAVE",
                            label: t("บันทึก"),
                            hidden: view,
                            seq: 3,
                            buttonProps: {
                                onClick: () => handleSubmit('SUBMIT')
                            },
                            type: "SAVE"
                        },
                    ]}
                />
            }
            content={
                <div className='w-full'>
                    <StateComponents
                        disabledAllField={view}
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    required: true,
                                    heading: t("ชื่อแบบทดสอบ"),
                                    helperText: errorMessage.title_name,
                                    placeholder: t("ระบุ"),
                                    value: title_name,
                                    onChange: (e) => {
                                        set_title_name(e.target.value);
                                        clearErrorMessage();
                                    },
                                }
                            }
                        ]}
                    />
                    <section className='w-full flex flex-col gap-5 mt-4'>
                        {data.map((list, index) => {
                            return (
                                <AccordionCustom
                                    defaultExpanded
                                    titleName={t("ข้อที่ {{no}}", { no: index + 1 })}
                                    enableButtonRight
                                    renderButtonRight={
                                        <div onClick={(e) => e.stopPropagation()} className='w-fit flex items-center gap-2 justify-end'>
                                            <div className='flex gap-2 justify-center items-center'>
                                                <div>{t("คะแนน")}</div>
                                                <div className='w-full max-w-[60px]'>
                                                    <StateComponents
                                                        disabledAllField={view}
                                                        typeProps={[
                                                            {
                                                                seq: 1,
                                                                gridProps: {
                                                                    xs: 12
                                                                },
                                                                type: "TEXT-MASK",
                                                                fieldProps: {
                                                                    mode: "one_digit",
                                                                    onChange: (e) => handleChange('online_course_form_subject_point', index, e.target.value),
                                                                    placeholder: t("ระบุ"),
                                                                    value: list.online_course_form_subject_point
                                                                }
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                            <StateComponents
                                                typeProps={[
                                                    {
                                                        seq: 1,
                                                        type: "SWITCH",
                                                        gridProps: {
                                                            xs: 12
                                                        },
                                                        fieldProps: {
                                                            disabled: view,
                                                            label: t("ต้องระบุคำตอบ"),
                                                            checked: list.answer_required,
                                                            onChange: (e) => handleChange('answer_required', index, e)
                                                        }
                                                    },
                                                ]}
                                            />
                                            {!view && (
                                                <IconButton onClick={() => handleDeleteForm(index)} sx={{ borderRadius: "10px", height: "fit-content" }}>
                                                    <IconComponent.DeleteIcon />
                                                </IconButton>
                                            )}
                                        </div>
                                    }
                                    content={
                                        <div className='w-full'>
                                            <StateComponents
                                                disabledAllField={view}
                                                otherProps={{ spacing: 2 }}
                                                typeProps={[
                                                    {
                                                        seq: 1,
                                                        type: "SELECT",
                                                        gridProps: {
                                                            xs: 12
                                                        },
                                                        fieldProps: {
                                                            labelId: "ss",
                                                            heading: t("รูปแบบ"),
                                                            ...(!list.form_type && {
                                                                renderValue: () => <span className='text-gray-200'>{t("ระบุ")}</span>,
                                                            }),
                                                            onChange: (e) => {
                                                                handleChange('form_type', index, e.target.value);
                                                                if (e.target.value === onlineCourseFormSurveys.DESCRIPTION) {
                                                                    handleChange('form_choice', index, [
                                                                        {
                                                                            form_choice_name: "",
                                                                            is_correct: false,
                                                                            id_online_course_form_choice: null
                                                                        }
                                                                    ]);
                                                                }
                                                            },
                                                            options: [
                                                                {
                                                                    label: t("ตัวเลือกเดียว"),
                                                                    value: onlineCourseFormSurveys.SINGLE_CHOICE,
                                                                    icon: <RadioButtonCheckedIcon />
                                                                },
                                                                {
                                                                    label: t("หลายตัวเลือก"),
                                                                    value: onlineCourseFormSurveys.MULTI_CHOICE,
                                                                    icon: <CheckBoxIcon />
                                                                },
                                                                {
                                                                    label: t("ระบุคำตอบ"),
                                                                    value: onlineCourseFormSurveys.DESCRIPTION,
                                                                    icon: <DescriptionIcon />
                                                                },
                                                            ],
                                                            selectId: "",
                                                            value: list.form_type
                                                        }
                                                    },
                                                    {
                                                        seq: 2,
                                                        gridProps: {
                                                            xs: 12
                                                        },
                                                        type: "TEXT_FIELD",
                                                        fieldProps: {
                                                            heading: t("คำถาม"),
                                                            inputHeight: 'auto',
                                                            onChange: (e) => handleChange('question', index, e.target.value),
                                                            multiline: true,
                                                            row: 4,
                                                            maxRows: 4,
                                                            disablePaddingMultiline: true,
                                                            placeholder: t("ระบุ"),
                                                            value: list.question
                                                        }
                                                    }
                                                ]}
                                            />


                                            {list.form_type === onlineCourseFormSurveys.SINGLE_CHOICE && (
                                                <div className='w-full flex flex-col mt-4'>
                                                    <RadioCustom
                                                        disabled={view}
                                                        className='px-1'
                                                        heading={t("ตัวเลือกทั้งหมด")}
                                                        value={list.answer}
                                                        onChange={(e) => {
                                                            handleChange('answer', index, e.target.value);
                                                        }}
                                                        dataList={list.form_choice?.length > 0 ? list.form_choice?.map((sub_list, sub_index) => {
                                                            return {
                                                                label: "",
                                                                value: `${sub_index}`,
                                                                renderAfter: <div className='w-full md:max-w-[500px] flex justify-start items-center'>
                                                                    <InputTextField
                                                                        disabled={view}
                                                                        onblur={() => {
                                                                            if (sub_list.form_choice_name?.length === 0) {
                                                                                handleDeleteFormChoice(index, sub_index)
                                                                            }
                                                                        }}
                                                                        value={sub_list.form_choice_name}
                                                                        onchange={(e) => {
                                                                            handleChangeFormChoice('form_choice_name', index, sub_index, e.target.value)
                                                                        }}
                                                                        variant='standard'
                                                                        disableUnderline
                                                                        borderColor='transparent'
                                                                    />
                                                                </div>
                                                            }
                                                        }) : []}
                                                    />
                                                    {!view && (
                                                        <div className='w-fit'>
                                                            <Button onClick={() => handleAddFormChoice(index)} startIcon={
                                                                <RadioButtonUncheckedIcon sx={{ mr: 2.3, color: "#F2F4F7" }} />
                                                            }>
                                                                {t("เพิ่มตัวเลือก")}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {list.form_type === onlineCourseFormSurveys.MULTI_CHOICE && (
                                                <div className='w-full flex flex-col justify-start items-start mt-5'>
                                                    <Typography>
                                                        {t("ตัวเลือกทั้งหมด")}
                                                    </Typography>
                                                    <div className='w-full flex flex-col mt-4'>
                                                        {list.form_choice?.map((sub_list, sub_index) => {
                                                            return (
                                                                <div className='w-full flex justify-start items-center gap-1'>
                                                                    <span className='w-fit'>
                                                                        <StateComponents
                                                                            disabledAllField={view}
                                                                            typeProps={[
                                                                                {
                                                                                    seq: 1,
                                                                                    type: "COMPONENT",
                                                                                    gridProps: {
                                                                                        xs: 12
                                                                                    },
                                                                                    fieldProps: {
                                                                                        element: (
                                                                                            <CheckBoxCustom
                                                                                                checked={sub_list.is_correct}
                                                                                                setChecked={(st) => handleChangeFormChoice('is_correct', index, sub_index, st)}
                                                                                            />
                                                                                        )
                                                                                    }
                                                                                }
                                                                            ]}
                                                                        />
                                                                    </span>
                                                                    <span>
                                                                        <InputTextField
                                                                            disabled={view}
                                                                            onblur={() => {
                                                                                if (sub_list.form_choice_name?.length === 0) {
                                                                                    handleDeleteFormChoice(index, sub_index)
                                                                                }
                                                                            }}
                                                                            value={sub_list.form_choice_name}
                                                                            onchange={(e) => {
                                                                                handleChangeFormChoice('form_choice_name', index, sub_index, e.target.value)
                                                                            }}
                                                                            variant='standard'
                                                                            disableUnderline
                                                                            borderColor='transparent'
                                                                        />
                                                                    </span>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    {!view && (
                                                        <div className='w-fit'>
                                                            <Button onClick={() => handleAddFormChoice(index)} startIcon={
                                                                <CheckBoxOutlineBlankIcon sx={{ mr: 2.3, color: "#F2F4F7" }} />
                                                            }>
                                                                {t("เพิ่มตัวเลือก")}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    }
                                />
                            )
                        })}
                    </section>

                    {!view && (
                        <section className='mt-6'>
                            <ContainerButton
                                justifyContent='flex-end'
                                buttonData={[
                                    {
                                        key: "ADD2",
                                        label: t("เพิ่ม"),
                                        seq: 1,
                                        type: "ADD2",
                                        buttonProps: {
                                            onClick: () => AddForm()
                                        }
                                    }
                                ]}
                            />
                        </section>
                    )}
                </div>
            }
        />
    )
}

export default ManageCourseTestDetail